import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './ListItems.styles';
import { I18n } from 'react-redux-i18n';

const ListItems = props => {
  return props.list && props.list.length === 0 ? (
    <span className={css(styles.noItem)}>
      {props.noItemsMesagge || I18n.t('edit.noItemsFound')}
    </span>
  ) : (
    <div className={css(styles.base)}>
      <ul className={css(styles.list)}>
        {props.list &&
          props.list.map(item => {
            return (
              <li
                className={css(styles.item)}
                onClick={() => props.onClick(item)}
                key={item.id}
              >
                {item.name}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default ListItems;



// WEBPACK FOOTER //
// ./src/components/common/listitems/ListItems.js